import KPIIcon from 'icon/kpi'
import React from 'react'

function KPISimple({ label, value }) {
  return (
    <div>
      <div class='grid grid-cols-3 items-center justify-between p-2 space-y-3 transition-all duration-500 bg-white border rounded-lg shadow hover:shadow-xl lg:p-5  lg:flex-row lg:space-y-0 lg:space-x-1'>
        <div class='flex col-span-1 items-center justify-center w-10 h-10 bg-gradient-to-tr to-[#F35658] from-[#C7381D] border border-green-200 rounded-full shadow-inner lg:h-15 lg:w-15'>
          <KPIIcon color={'white'} />
        </div>
        <div class='text-right col-span-2'>
          <p class='text-xs text-gray-600 capitalize'>{label}</p>
          <p class=' font-semibold text-gray-600'>{value}</p>
        </div>
      </div>
    </div>
  )
}

export default KPISimple
